import { IExperiment, TExperimentsState } from '../../types/experiments';

export function getAbUseExperiment(experiments: TExperimentsState, experimentName: string): IExperiment | undefined {
  return experimentName in experiments ? { experimentName, groupName: experiments[experimentName] } : undefined;
}
